import { InputWrapError } from '../../../../Input'
import Text from '../../../../Text'

import * as styles from './AppointmentFormModalHintedControl.module.css'

function AppointmentFormModalHintedControl({
  Control,
  hint,
  isHintError = false,
  ...restProps
}) {
  return (
    <div className={styles.hintedControl}>
      <Control {...restProps} />
      {hint ? (
        isHintError ? (
          <InputWrapError text={hint} />
        ) : (
          <Text className={styles.hint}>{hint}</Text>
        )
      ) : null}
    </div>
  )
}

export default AppointmentFormModalHintedControl
